import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconExpandVertical$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconExpandVertical extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4400da34bd71c1e285f2fb15bbf7bc9323ea4783', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c6e1ac603f86864da5d0a44de854e9b2bf65f970', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cfb0c5483f60a75a81485318acde1a55afd87c6a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.482 7c.444 0 .682-.541.389-.887l-2.482-2.93a.507.507 0 0 0-.778 0l-2.482 2.93c-.293.346-.055.887.39.887zM3 10.75a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5zm5.129 5.137c-.293-.346-.055-.887.39-.887h4.963c.444 0 .682.541.389.887l-2.482 2.93a.506.506 0 0 1-.778 0z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-expand-vertical", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-expand-vertical"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-expand-vertical":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconExpandVertical$1);
            }
            break;
    } });
}

const CosmosIconExpandVertical = CosmosIconExpandVertical$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconExpandVertical, defineCustomElement };
